import { BrandErrorFragment } from "@saleor/fragments/types/BrandErrorFragment";
import { commonMessages } from "@saleor/intl";
import { BrandErrorCode } from "@saleor/types/globalTypes";
import { IntlShape } from "react-intl";

import commonErrorMessages from "./common";

function getBrandErrorMessage(
  err: Omit<BrandErrorFragment, "__typename"> | undefined,
  intl: IntlShape
): string {
  if (err) {
    switch (err.code) {
      case BrandErrorCode.GRAPHQL_ERROR:
        return intl.formatMessage(commonErrorMessages.graphqlError);
      case BrandErrorCode.REQUIRED:
        return intl.formatMessage(commonMessages.requiredField);
      case BrandErrorCode.INVALID:
        return intl.formatMessage(commonErrorMessages.invalid);
      default:
        return intl.formatMessage(commonErrorMessages.unknownError);
    }
  }

  return undefined;
}

export default getBrandErrorMessage;
